import * as React from 'react';
import style from '../RPCApiRequestDisplay.scss';
import { Button } from '../../../../../Layout/Button';

interface TryItOutRPCButtonProps {
  artifactId: string;
  serviceName: string;
  methodName: string;
}

export const TryItOutRPCButton = ({
  artifactId,
  serviceName,
  methodName,
}: TryItOutRPCButtonProps) => {
  return (
    <Button
      className={style.playgroundButton}
      size="tiny"
      dataHook="try-it-out-button"
      as="a"
      target="_blank"
      href={`https://pbo.wix.com/fire-console/?artifact=${artifactId}&service=${serviceName}&method=${methodName}`}
    >
      Try It Out
    </Button>
  );
};
